import EditFormGroup from "components/form/EditFormGroup";
import React, { forwardRef } from "react";

export default forwardRef(function FlavourForm(
  {
    data = {},
    onChange = () => {},
    onError = () => {},
    // define onchange parameter 'state', 'event', 'name-value'
    type = "state",
  },
  ref
) {
  return (
    <div>
      <EditFormGroup
        ref={ref}
        data={data}
        onChange={onChange}
        onError={onError}
        type={type}
        layout={[
          {
            name: "name",
            label: "Name",
            type: "text",
            required: true,
            size: "small",
          },
          {
            name: "price",
            label: "Price (Subscription)",
            type: "money",
            required: true,
            size: "small",
          },
          {
            name: "price_oneoff",
            label: "Price (One off order)",
            type: "money",
            required: true,
            size: "small",
          },
          {
            name: "image",
            label: "Image",
            type: "file",
            // required: true,
            size: "small",
          },
        ]}
        isLabel
        fullWidth={true}
        direction="column"
        spacing={2}
      />
    </div>
  );
});
